import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FiMapPin, FiPhone, FiMail, FiSave } from 'react-icons/fi';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase/firebase';

const LocationManager = () => {
  const [location, setLocation] = useState({
    name: 'Holiday, FL',
    description: 'In MT. Vernon Center in the north building.',
    address: '2238 US-19, Holiday, FL 34690',
    phone: '727.940.5580',
    email: 'Tajohnson09301979@gmail.com',
    mapsUrl: 'https://www.google.com/maps/dir//2238+US-19,+Holiday,+FL+34690/@28.1913849,-82.8217296,12z'
  });
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadLocation();
  }, []);

  const loadLocation = async () => {
    try {
      const docRef = doc(db, 'shop', 'location');
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        setLocation(docSnap.data());
      }
    } catch (error) {
      console.error('Error loading location:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field, value) => {
    setLocation({ ...location, [field]: value });
  };

  const handleSave = async () => {
    try {
      await setDoc(doc(db, 'shop', 'location'), location);
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (error) {
      console.error('Error saving location:', error);
      alert('Failed to save location. Please try again.');
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-white">Loading location...</div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
        <FiMapPin className="text-2xl sm:text-3xl text-white" />
        <h2 className="text-xl sm:text-2xl font-bold text-white">Location Information</h2>
      </div>

      <div className="space-y-4 sm:space-y-6">
        <div className="bg-white/5 rounded-xl p-3 sm:p-4 border border-white/10">
          <label className="block text-white/80 mb-2 text-xs sm:text-sm font-medium">
            Location Name
          </label>
          <input
            type="text"
            value={location.name}
            onChange={(e) => handleChange('name', e.target.value)}
            className="w-full bg-white/10 border border-white/20 rounded-lg px-3 sm:px-4 py-2 sm:py-3 text-white placeholder-white/40 focus:outline-none focus:border-white/40 text-sm sm:text-base"
            placeholder="e.g., Holiday, FL"
          />
        </div>

        <div className="bg-white/5 rounded-xl p-3 sm:p-4 border border-white/10">
          <label className="block text-white/80 mb-2 text-xs sm:text-sm font-medium">
            Description
          </label>
          <textarea
            value={location.description}
            onChange={(e) => handleChange('description', e.target.value)}
            className="w-full bg-white/10 border border-white/20 rounded-lg px-3 sm:px-4 py-2 sm:py-3 text-white placeholder-white/40 focus:outline-none focus:border-white/40 text-sm sm:text-base"
            rows="3"
            placeholder="Brief description of the location"
          />
        </div>

        <div className="bg-white/5 rounded-xl p-3 sm:p-4 border border-white/10">
          <label className="block text-white/80 mb-2 text-xs sm:text-sm font-medium flex items-center gap-2">
            <FiMapPin className="text-base sm:text-lg" />
            Street Address
          </label>
          <input
            type="text"
            value={location.address}
            onChange={(e) => handleChange('address', e.target.value)}
            className="w-full bg-white/10 border border-white/20 rounded-lg px-3 sm:px-4 py-2 sm:py-3 text-white placeholder-white/40 focus:outline-none focus:border-white/40 text-sm sm:text-base"
            placeholder="Full street address"
          />
        </div>

        <div className="bg-white/5 rounded-xl p-3 sm:p-4 border border-white/10">
          <label className="block text-white/80 mb-2 text-xs sm:text-sm font-medium flex items-center gap-2">
            <FiPhone className="text-base sm:text-lg" />
            Phone Number
          </label>
          <input
            type="tel"
            value={location.phone}
            onChange={(e) => handleChange('phone', e.target.value)}
            className="w-full bg-white/10 border border-white/20 rounded-lg px-3 sm:px-4 py-2 sm:py-3 text-white placeholder-white/40 focus:outline-none focus:border-white/40 text-sm sm:text-base"
            placeholder="Phone number"
          />
        </div>

        <div className="bg-white/5 rounded-xl p-3 sm:p-4 border border-white/10">
          <label className="block text-white/80 mb-2 text-xs sm:text-sm font-medium flex items-center gap-2">
            <FiMail className="text-base sm:text-lg" />
            Email Address
          </label>
          <input
            type="email"
            value={location.email}
            onChange={(e) => handleChange('email', e.target.value)}
            className="w-full bg-white/10 border border-white/20 rounded-lg px-3 sm:px-4 py-2 sm:py-3 text-white placeholder-white/40 focus:outline-none focus:border-white/40 text-sm sm:text-base"
            placeholder="Contact email"
          />
        </div>

        <div className="bg-white/5 rounded-xl p-3 sm:p-4 border border-white/10">
          <label className="block text-white/80 mb-2 text-xs sm:text-sm font-medium">
            Google Maps Directions URL
          </label>
          <input
            type="url"
            value={location.mapsUrl}
            onChange={(e) => handleChange('mapsUrl', e.target.value)}
            className="w-full bg-white/10 border border-white/20 rounded-lg px-3 sm:px-4 py-2 sm:py-3 text-white placeholder-white/40 focus:outline-none focus:border-white/40 text-xs sm:text-sm break-all"
            placeholder="Google Maps directions link"
          />
          <p className="mt-2 text-white/40 text-xs">
            Get your Google Maps link by searching for your address and clicking "Share" → "Copy link"
          </p>
        </div>
      </div>

      <div className="mt-4 sm:mt-6 flex justify-end">
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={handleSave}
          className={`flex items-center gap-2 px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg font-semibold transition-all text-sm sm:text-base ${
            saved
              ? 'bg-green-500 text-white'
              : 'bg-white text-slate-900 hover:bg-gray-100'
          }`}
        >
          <FiSave />
          <span>{saved ? 'Saved!' : 'Save Changes'}</span>
        </motion.button>
      </div>
    </div>
  );
};

export default LocationManager;